import styled from "styled-components";

export const NotesContainer = styled.div<{ref: any}>`
	display: flex;
    position: relative;
    min-width: 24px;
`;

export const NotesTooltip = styled.div`
	position: absolute;
    padding: 12px;
    background: rgba(161, 170, 198, 1);
    border-radius: 24px;
    color: #fff;
    max-width: 250px;
    min-width: 24px;
    width: max-content;
    position: fixed;
    transition-duration: .1s;
`;